import axios from "axios";
import {InitPage} from "../index";

declare var App: any;
declare var storeLocation: string;
declare var showInfoDialog;
declare var showErrorDialog;
declare var printJobs;
declare var perPage;
declare var printedQty;

class BulkPrint {
    printTemplateChannel: any;
    bulkPrintingChannel: any;

    init() {
        this.printTemplateChannel = this.connectToTemplate();
        this.bulkPrintingChannel = this.connectToBulkPrinting();
        this.htmlInitialize();
    }

    htmlInitialize() {
        let _this = this;
        $("#showImportFile").on("click", function(){
            $("#import_file").modal();
        });

        $('#hidePrintedLabels').change(function() {
            var checkbox = $(this);
            if (checkbox.prop('checked')) {
                document.cookie = `bulk_prints_${storeLocation}_hide_printed=1;path=/`;
            } else {
                document.cookie = `bulk_prints_${storeLocation}_hide_printed=0;path=/`;
            }
            _this.updatePrintTempalesData(true);
        });

        $('.print_tag_data').change(function() {
            var checkbox = $(this);
            if (checkbox.prop('checked')) {
                printJobs.push(parseInt(checkbox.attr('data')));
            } else {
                _this.removeFromArrayByValue(parseInt(checkbox.attr('data')));
            }

        });

        $("#showCustomImportFile").on("click", function(){
            $("#custom_import_file").modal();
        });

        $("#selectAllBoxes").on("click", function(){
            $.each($(".print_tag_data"), function(){
                $(this).prop("checked", ((true as unknown) as string));
            });
        });

        $("#unSelectAllBoxes").on("click", function(){
            $.each($(".print_tag_data"), function(){
                $(this).prop("checked", ((false as unknown) as string));
            });
        });

        $("#upload_file_form").submit((e) => {
            e.preventDefault();
            _this.updateLoadingStatus(true);
            ($("#upload_file_form") as any).ajaxSubmit({
              url: $(this).attr("action"),
              type: "post",
              dataType: "JSON",
              success: (data) => {
                _this.updateLoadingStatus(false);
                console.log(data);
                $("#finished_status").show();
                $("#uploaded_status").show();
                $("#finished_stats").show();
                console.log(`<i class="fa fa-check text-success"></i>Detected ${data.total_records} Records<br>${data.failed} Error(s) Found<br>${data.print_lines} Lines to Print<br>${data.tags} Tags to Print`)
                $("#finished_stats").html(`<i class="fa fa-check text-success"></i>Detected ${data.total_records} Records<br>${data.failed} Error(s) Found<br>${data.print_lines} Lines to Print<br>${data.tags} Tags to Print`);
                $("#submitUpload").hide();
                $("#proceedToPrinting").show();
                $("#proceedToPrinting").on("click", function(){
                    window.location.reload();
                })
                // resetFileInput();
              },
              error: ({responseJSON}) => {
                // showError(responseJSON.error);
                _this.updateLoadingStatus(false);
                console.log(responseJSON.errors);

                $("#importing_error").text(responseJSON.errors);
                $("#importing_error").show();
              }
            });
        });

        $("#custom_upload_file_form").submit((e) => {
            e.preventDefault();
            _this.updateLoadingStatus(true);
            $("#custom_importing_error").text('');
            $("#custom_importing_error").hide();
            ($("#custom_upload_file_form") as any).ajaxSubmit({
              url: $(this).attr("action"),
              type: "post",
              dataType: "JSON",
              success: (data) => {
                _this.updateLoadingStatus(false);
                $("#custom_finished_status").show();
                $("#custom_uploaded_status").show();
                $("#custom_finished_stats").show();
                $("#custom_finished_stats").html(`<i class="fa fa-check text-success"></i>${data.total_records} Record(s) Detected<br>${data.failed} Error(s) Found<br>${data.print_lines} SKU added to the queue<br>${data.tags} Prints total`);
                $("#custom_submitUpload").hide();
                $("#customProceedToPrinting").show();
                if (data.not_import.length) {
                  let log_items = ''
                  $.each(data.not_import, function(i, error){
                    log_items += `${error.item}: ${error.errors}<br>`
                  });
                  $("#custom_importing_error").html(log_items);
                  $("#custom_importing_error").show();
                }
                $("#customProceedToPrinting").on("click", function(){
                    window.location.reload();
                })
              },
              error: ({responseJSON}) => {
                // showError(responseJSON.error);
                _this.updateLoadingStatus(false);
                console.log(responseJSON.errors);

                $("#custom_importing_error").html(`Error Detected Import cancelled! <br/> ${responseJSON.errors}`);
                $("#custom_importing_error").show();
              }
            });
        });

        $("#bulkPrint").submit((e) => {
            e.preventDefault();
            let ids: string[];
            ids = [];
            $.each($(".print_tag_data:checked"), function(){
                ids.push(($(this).val() as string));
            });
            $("#print_jobs").val(ids);
            ($("#bulkPrint") as any).ajaxSubmit({
                url: $(this).attr("action"),
                type: "post",
                dataType: "JSON",
                success: (data) => {
                  if (data.success == true) {
                      $('#startButton').attr('style','display: none !important');
                      $('#stopButton').show();
                  }
                  showInfoDialog(data.message);
                },
                error: (error) => {
                  showErrorDialog(error.message);
                }
            });
        });

        $('#stopButton').on('click', function(){
          $('#startButton').removeAttr('style');
          $(this).attr('style','display: none !important');
        });
    }

    connectToTemplate(){
        let _this = this;
        App.cable.subscriptions.create(
            // Connection configuration
            {
              channel: "PrintTemplateChannel",
              tenant_code: storeLocation
            },
            {
              connected() { console.log("'connected'") },
              disconnected() { /* Called when the subscription has been terminated by the server */ },
              received(data: any) { console.log(data); _this.updateStatus(data) }
            }
          );
    }

    connectToBulkPrinting(){
        let _this = this;
        App.cable.subscriptions.create(
            // Connection configuration
            {
              channel: "BulkPrintChannel",
              tenant_code: storeLocation
            },
            // Pass in connection callbacks
            {
              connected() { /* Called when the subscription is ready for use on the server */ },
              disconnected() { /* Called when the subscription has been terminated by the server */ },
              received(data: any) {
                  console.log(data);
                  if(data.type == "progress") {
                    _this.updatePrintProgress(data);
                  } else if (data.type == "line" ) {
                    _this.updateLineProgress(data);
                  }
              }
            }
          );
    }

    updatePrintTempalesData(forceUpdate = false) {
        if (this.hidePrinted() || forceUpdate) {
            axios.get(`/${storeLocation.replace(/_/g, "/")}/bulk_prints.json`, { params: { print_jobs: printJobs }})
            .then((resp) => {
                $('#bulkPrintTemplatesTable').html(resp.data.content);
                $('#bulkPrintTemplatesPagination').html(resp.data.pagination);
                $('#bulkPrintTemplatesRemainingQty').html(resp.data.remaining_qty);
            })
            .catch(() => {
            });
        }
    }

    hidePrinted() {
        return this.getCookie(`bulk_prints_${storeLocation}_hide_printed`) == '1'
    }

    arrayToQueryString(arr) {
        return arr.map(value => `print_jobs[]=${encodeURIComponent(value)}`).join('&');
    }

    getCookie(name) {
        var cookiePattern = new RegExp("(?:(?:^|.*;)\\s*" + name + "\\s*\\=\\s*([^;]*).*$)|^.*$");
        return document.cookie.replace(cookiePattern, "$1");
    }

    removeFromArrayByValue(value) {
        const index = printJobs.indexOf(value);
        if (index !== -1) {
            printJobs.splice(index, 1);
        }
    }

    updatePrintProgress(data) {
        console.log(data);
        $("#job_progress").html(`<br/><span class='text-muted'> Last/Present Job at </span>${data.progress} of ${data.total}`)
        printedQty += 1;
        if (perPage > printedQty) {
            if(this.hidePrinted()) {
                $(`#${data.item_number}-tr`).hide();
            }
        } else {
            this.updatePrintTempalesData();
        }
    }

    updateLineProgress(data) {
        $(`#${data.item_number}-printTime`).text(data.time);
        $(`#${data.item_number}-status`).text(data.status);
        var remainingQty = $('#bulkPrintTemplatesRemainingQty').html();
        var parsedQty = parseInt(remainingQty);
        parsedQty = isNaN(parsedQty) ? 0 : Math.max(parsedQty - 1, 0);
        $('#bulkPrintTemplatesRemainingQty').html(
            parsedQty.toString()
        );
    }

    updateLoadingStatus(loading){
        if(loading) {
          $(".import_loading").show();
          $(".import_not_loading").hide();
        } else {
          $(".import_loading").hide();
          $(".import_not_loading").show();
        }
    }

    updateStatus(data) {
        $("#uploaded_status").show();
        $("#imported_items_stat").html(`Imported ${data.success} of ${data.total_count}`)
    }
}

export function LoadPage() {
    InitPage("bulk_prints", () => {
        const rfid = new BulkPrint();
        rfid.init();
    });
}
